// Onboarding quiz config — NO emojis on any options (clean professional UX).

export const SKIN_TYPES = [
  { value: "Dry" },
  { value: "Oily" },
  { value: "Combination" },
  { value: "Sensitive" },
  { value: "Normal" },
  { value: "Acne-prone" },
  { value: "Not sure" },
];

// 12 inclusive skin tone swatches — exact hex per spec
export const SKIN_TONES = [
  { name: "Porcelain", hex: "#F5D5B8" },
  { name: "Fair", hex: "#E8C09A" },
  { name: "Light", hex: "#D4A574" },
  { name: "Medium", hex: "#C08050" },
  { name: "Tan", hex: "#8B5E3C" },
  { name: "Deep", hex: "#5C3018" },
  { name: "Rich", hex: "#3A1E0A" },
  { name: "Espresso", hex: "#2E1608" },
  { name: "Warm Olive", hex: "#C4956A" },
  { name: "Golden", hex: "#A07850" },
  { name: "Neutral", hex: "#9C8070" },
  { name: "Cool Rose", hex: "#D0A090" },
];

export const HAIR_TYPES = [
  "Straight 1A-1C",
  "Wavy 2A-2C",
  "Curly 3A-3C",
  "Coily 4A-4B",
  "Kinky 4C",
  "Locs",
  "Protective styles",
  "Chemically treated",
];

export const CONCERNS = {
  skin: [
    "Hyperpigmentation",
    "Dark spots",
    "Acne",
    "Dryness",
    "Oiliness",
    "Uneven tone",
    "Fine lines",
    "Sensitivity",
    "Redness",
  ],
  hair: [
    "Breakage",
    "Dryness",
    "Low growth",
    "Frizz",
    "Scalp issues",
    "Thinning",
    "Heat damage",
    "Lack of definition",
  ],
};

export const GOALS = [
  "Glow and Radiance",
  "Even skin tone",
  "Deep hydration",
  "Fade hyperpigmentation",
  "Anti-aging",
  "Hair growth",
  "Reduce breakage",
  "Scalp health",
  "Strengthen hair",
  "Define curls",
];


// Concerns are stored as prefixed values ("skin:Dryness", "hair:Dryness") so
// the two onboarding chip groups stay independent. Downstream consumers
// (product matching, ilike keyword search) want the raw label only.
export function cleanConcern(c) {
  if (typeof c !== "string") return c;
  return c.replace(/^(skin|hair):/i, "");
}

export function cleanConcerns(arr = []) {
  return arr.map(cleanConcern);
}

// Returns just the concerns tagged for the given category ("skin" or "hair").
// Unprefixed legacy values are treated as matching both categories.
export function concernsFor(arr = [], category) {
  const prefix = `${category}:`;
  return arr
    .filter((c) => typeof c === "string" && (c.toLowerCase().startsWith(prefix) || !c.includes(":")))
    .map(cleanConcern);
}
